import { gql } from "@apollo/client";

export const CreateImportInstalledBaseTask = gql`
    mutation CreateImportInstalledBaseTask ($input: TdaBackgroundTaskImportInstalledBaseAttributesInput!){
        createImportInstalledBaseTask(input: $input) {
            id
            taskId
        }
    }
`;
